/**
 * BDL Mentoria — multi-step + POST Workflow Webhooks (origem=MENTORIA).
 * Máscaras BR: [data-phone-br] e [data-currency-br].
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-bdl-flow-form][data-origem="MENTORIA"]').forEach(initForm);

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function formatBrCurrency(value) {
    var digits = digitsOnly(value).slice(0, 12);
    if (!digits.length) return '';

    var cents = parseInt(digits, 10);
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + integer + ',' + parts[1];
  }

  function syncCurrencyValidity(field) {
    if (!field) return;

    if (!field.value.trim()) {
      field.setCustomValidity('');
      return;
    }

    if (digitsOnly(field.value).length > 0) {
      field.setCustomValidity('');
    } else {
      field.setCustomValidity('Informe um valor em reais.');
    }
  }

  function bindCurrencyFields(form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-currency-br]'));

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        field.value = formatBrCurrency(field.value);
        syncCurrencyValidity(field);
      });

      field.addEventListener('blur', function () {
        field.dataset.touched = 'true';
        syncCurrencyValidity(field);
      });
    });
  }

  function formatBrPhone(value) {
    var digits = digitsOnly(value).slice(0, 11);

    if (!digits.length) return '';
    if (digits.length <= 2) return '(' + digits;
    if (digits.length <= 6) {
      return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    }
    if (digits.length <= 10) {
      return (
        '(' +
        digits.slice(0, 2) +
        ') ' +
        digits.slice(2, 6) +
        '-' +
        digits.slice(6)
      );
    }

    return (
      '(' +
      digits.slice(0, 2) +
      ') ' +
      digits.slice(2, 7) +
      '-' +
      digits.slice(7)
    );
  }

  function isValidBrPhone(value) {
    var digits = digitsOnly(value);

    if (digits.length === 10) {
      return /^[1-9][1-9]\d{8}$/.test(digits);
    }
    if (digits.length === 11) {
      return /^[1-9][1-9]9\d{8}$/.test(digits);
    }
    return false;
  }

  function syncPhoneValidity(field) {
    if (!field) return;

    if (!field.value.trim()) {
      field.setCustomValidity('');
      return;
    }

    if (isValidBrPhone(field.value)) {
      field.setCustomValidity('');
    } else {
      field.setCustomValidity('Informe um WhatsApp válido com DDD, no formato (00) 00000-0000.');
    }
  }

  function bindPhoneFields(form) {
    var phones = Array.prototype.slice.call(form.querySelectorAll('[data-phone-br]'));

    phones.forEach(function (field) {
      field.addEventListener('input', function () {
        field.value = formatBrPhone(field.value);
        syncPhoneValidity(field);
      });

      field.addEventListener('blur', function () {
        field.dataset.touched = 'true';
        syncPhoneValidity(field);
      });

      syncPhoneValidity(field);
    });
  }

  function buildBodySummary(form) {
    var bodyField = form.querySelector('[data-mentoria-apply-body-field]');
    if (!bodyField) return;

    var lines = ['Aplicação Mentoria — respostas:', ''];
    var fields = Array.prototype.slice.call(
      form.querySelectorAll('input, select, textarea')
    );

    fields.forEach(function (field) {
      var name = field.getAttribute('name') || '';
      if (!name || name === 'contact[body]' || name === 'contact[id]') return;
      if (field.type === 'hidden' && name.indexOf('contact[') === 0) {
        lines.push(name.replace(/^contact\[|\]$/g, '') + ': ' + field.value);
        return;
      }
      if (field.type === 'hidden') return;
      if (!field.value || !String(field.value).trim()) return;

      var label = '';
      var step = field.closest('[data-form-step]');
      if (step && step.dataset.stepLabel) {
        label = step.dataset.stepLabel + ' — ';
      }
      var labelEl = field.closest('label');
      var labelText = labelEl && labelEl.querySelector('.bdl-mentoria-apply__label');
      if (labelText) {
        label += labelText.textContent.replace(/\*$/, '').trim();
      } else {
        label += name.replace(/^contact\[|\]$/g, '');
      }

      lines.push(label + ': ' + String(field.value).trim());
    });

    bodyField.value = lines.join('\n');
  }

  function initForm(form) {
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-form-step]'));
    if (!steps.length) return;

    var dots = Array.prototype.slice.call(form.querySelectorAll('[data-mentoria-apply-dot]'));
    var fill = form.querySelector('[data-mentoria-apply-progress-fill]');
    var progress = form.querySelector('[data-mentoria-apply-progress]');
    var nextBtn = form.querySelector('[data-mentoria-apply-next]');
    var backBtn = form.querySelector('[data-mentoria-apply-back]');
    var nextLabel = form.querySelector('[data-mentoria-apply-next-label]');
    var actions = form.querySelector('[data-mentoria-apply-actions]');
    var card = form.querySelector('[data-mentoria-apply-main-card]') || form.querySelector('.bdl-mentoria-apply__card');
    var successEl = form.querySelector('[data-bdl-flow-success]');
    var errorEl = form.querySelector('[data-bdl-flow-error]');
    var bodyEl = form.querySelector('[data-mentoria-apply-body]');

    var current = 0;
    var lastIndex = steps.length - 1;
    var submitting = false;

    bindPhoneFields(form);
    bindCurrencyFields(form);

    function showStep(index) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });

      if (backBtn) backBtn.hidden = index === 0;

      if (nextLabel) {
        nextLabel.textContent = index === lastIndex ? 'Enviar respostas' : 'Continuar';
      }

      updateProgress(index);

      if (card && index !== 0) {
        card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function updateProgress(index) {
      if (!dots.length) return;

      dots.forEach(function (dot, i) {
        if (i < index) {
          dot.dataset.state = 'done';
        } else if (i === index) {
          dot.dataset.state = 'current';
        } else {
          delete dot.dataset.state;
        }
      });

      if (fill) {
        var totalGaps = dots.length - 1;
        var minWidth = 12;
        if (totalGaps <= 0 || index === 0) {
          fill.style.width = minWidth + 'px';
        } else {
          var track = fill.parentElement;
          var trackWidth = track ? track.getBoundingClientRect().width : 0;
          var percent = index / totalGaps;
          var target = Math.max(minWidth, trackWidth * percent);
          fill.style.width = target + 'px';
        }
      }
    }

    function validateStep(step) {
      var fields = Array.prototype.slice.call(step.querySelectorAll('input, select, textarea'));
      var firstInvalid = null;

      fields.forEach(function (field) {
        if (field.hasAttribute('data-phone-br')) {
          syncPhoneValidity(field);
        }
        if (field.hasAttribute('data-currency-br')) {
          syncCurrencyValidity(field);
        }

        if (!field.willValidate) return;

        field.dataset.touched = 'true';
        if (!field.checkValidity() && !firstInvalid) {
          firstInvalid = field;
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        return false;
      }
      return true;
    }

    function validateAllSteps() {
      for (var i = 0; i < steps.length; i += 1) {
        if (!validateStep(steps[i])) {
          current = i;
          showStep(current);
          return false;
        }
      }
      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (submitting) return;

        var step = steps[current];
        if (!validateStep(step)) return;

        if (current < lastIndex) {
          current += 1;
          showStep(current);
          return;
        }

        if (!validateAllSteps()) return;

        buildBodySummary(form);
        submitting = true;
        if (nextBtn) nextBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;

        if (!window.BdlFlowWebhook) {
          submitting = false;
          if (nextBtn) nextBtn.disabled = false;
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.focus();
          }
          return;
        }

        var url = form.getAttribute('data-webhook-url') || '';
        var key = form.getAttribute('data-webhook-key') || '';
        var origem = form.getAttribute('data-origem') || 'MENTORIA';
        var payload = window.BdlFlowWebhook.buildPayload(origem, form);

        window.BdlFlowWebhook.post(url, key, payload)
          .then(function () {
            if (progress) progress.hidden = true;
            if (bodyEl) bodyEl.hidden = true;
            if (actions) actions.hidden = true;
            if (card) card.setAttribute('data-state', 'success');
            if (successEl) {
              successEl.hidden = false;
              successEl.removeAttribute('hidden');
            }
            if (card) {
              card.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          })
          .catch(function () {
            submitting = false;
            if (nextBtn) nextBtn.disabled = false;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.focus();
            }
          });
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (submitting) return;
        if (current > 0) {
          current -= 1;
          showStep(current);
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    form.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
          event.preventDefault();
          if (nextBtn && !submitting) nextBtn.click();
        }
      },
      true
    );

    showStep(current);
  }
})();
